import { render, staticRenderFns } from "./messageManage.vue?vue&type=template&id=17d07b52&"
import script from "./messageManage.vue?vue&type=script&lang=js&"
export * from "./messageManage.vue?vue&type=script&lang=js&"
import style0 from "./messageManage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports